'use strict';
/*
  pop — bold karaoke captions. Heavy Impact words with a thick black outline and
  a punchy scale on entry; the key word fills a bright accent (green/yellow/pink
  by word) with a beat bounce. The ubiquitous, highly legible Reels/TikTok look.
*/
const { FONTS } = require('../lib/draw');
const { layoutCue } = require('./_common');

const palette = { bg: '#0a0a0a', fg: '#ffffff', accent: '#00e676', ink: '#0a0a0a' };
const ACCENTS = ['#00e676', '#ffe14d', '#ff3d7f', '#23e0ff'];
function hash(s){ let h = 2166136261; for (let i = 0; i < s.length; i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }

function init(st){ st.s.font = st.tk.registerFamily('ForgePop', FONTS.impact) || undefined; st.s.pop = 0; }
function onBeat(st, power){ st.s.pop = Math.min(1, st.s.pop + power * 0.6); }

function background(ctx, st){
  const { W, H } = st; st.s.pop *= 0.84;
  if (!st.overlayMode) {
    const g = ctx.createRadialGradient(st.CX, H * 0.42, 60, st.CX, H * 0.42, W * 0.9);
    g.addColorStop(0, '#1a1a1a'); g.addColorStop(1, '#050505');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  } else {
    const g = ctx.createLinearGradient(0, H * 0.5, 0, H);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.5)');
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.5, W, H * 0.5);
  }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  const pop = emph ? 1 + st.s.pop * 0.10 : 1;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl * pop, scl * pop);
  ctx.font = tk.font(px, 900, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.fillStyle = 'rgba(255,255,255,0.4)'; ctx.fillText(T, 0, 0); ctx.restore(); return; }
  ctx.shadowColor = 'rgba(0,0,0,0.5)'; ctx.shadowBlur = px * 0.18; ctx.shadowOffsetY = px * 0.05;
  ctx.lineJoin = 'round'; ctx.lineWidth = px * 0.20; ctx.strokeStyle = palette.ink; ctx.strokeText(T, 0, 0);
  ctx.shadowColor = 'transparent';
  ctx.fillStyle = emph ? ACCENTS[hash(T) % ACCENTS.length] : palette.fg; ctx.fillText(T, 0, 0);
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.72 : 'center';
  layoutCue(ctx, st, { sizes: { big: 150, mid: 122, small: 70 }, anchor, safeW: 0.9, reveal: 0.18, stagger: 0.045, trail: 1, trans: 0.16, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.42 : 0.6, 340), 0, 0);
  if (!st.overlayMode) { ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6); }
}

module.exports = { id: 'pop', label: 'Karaoke · word-by-word', palette, init, background, drawCue, overlay, onBeat, paintToken };
